import React from 'react';

import { isEmpty } from 'lodash-es';

import AlertBlock from '../../../../../components/AlertBlock';

import DashboardTable from '../../../../dashboard-general/DashboardTable';
import tableColumns from '../../../../dashboard-general/tableColumns';
import tableRows from '../../../../dashboard-general/tableRows';
import { initParams } from '../configs';

const TrendingAppsTable = () => {
  const { trendingUpReport, trendingDownReport } = initParams();
  return (
    <div className="top-charts-main trending-apps-table">
      <div className="top-charts-table-box">
        {!isEmpty(initParams()) ? (
          <div className="pos-rel row">
            <DashboardTable
              defaultSortBy="last_24_hours_row"
              columns={tableColumns.trendingApps}
              rows={tableRows.trendingAppsRow(trendingUpReport)}
              tableName="Trending Up"
              iconClasses="hicon-arrow-up-circle text-green"
              withKindButtons
              className="trending-up-table"
            />
            <DashboardTable
              defaultSortBy="last_24_hours_row"
              sortOrder="asc"
              columns={tableColumns.trendingApps}
              rows={tableRows.trendingAppsRow(trendingDownReport)}
              tableName="Trending Down"
              iconClasses="hicon-arrow-down-circle text-rose"
              withKindButtons
              className="trending-down-table"
            />
          </div>
        ) : (
          <AlertBlock type="warning" iconClass="hicon-warning">
            <p>Sorry, the Top Apps report is not available for apps matching these criteria.</p>
          </AlertBlock>
        )}
      </div>
    </div>
  );
};

export default TrendingAppsTable;
